
(function(){
  const drawer=document.querySelector('[data-cart-drawer]');
  const overlay=document.querySelector('[data-cart-overlay]');
  const openBtn=document.querySelector('[data-open-cart]');
  const closeBtn=document.querySelector('[data-close-cart]');
  const itemsEl=document.querySelector('[data-drawer-items]');
  const totalEl=document.querySelector('[data-drawer-total]');
  const countEls=document.querySelectorAll('[data-cart-count]');
  function money(cents){return new Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS',maximumFractionDigits:0}).format(cents/100)}
  function open(){if(drawer){drawer.classList.add('open');overlay.classList.add('open');load()}}
  function close(){if(drawer){drawer.classList.remove('open');overlay.classList.remove('open')}}
  async function load(){
    try{
      const r=await fetch('/cart.js'); const c=await r.json();
      countEls.forEach(x=>x.textContent=c.item_count);
      if(totalEl) totalEl.textContent=money(c.total_price);
      if(!itemsEl)return;
      if(!c.items.length){itemsEl.innerHTML='<div class="drawer-empty">Tu carrito está vacío.<br><br><a class="btn btn-secondary" href="/">Seguir comprando</a></div>';return}
      itemsEl.innerHTML=c.items.map(i=>`<div class="drawer-item">
        <img src="${i.image||''}" alt="">
        <div><h4>${escapeHtml(i.product_title)}</h4><p>${money(i.final_line_price)} · Cant.: ${i.quantity}</p></div>
        <button type="button" data-remove="${i.key}" style="background:none;border:0;color:#777d87;cursor:pointer">×</button>
      </div>`).join('');
      itemsEl.querySelectorAll('[data-remove]').forEach(b=>b.onclick=()=>update(b.dataset.remove,0));
    }catch(e){}
  }
  async function update(key,quantity){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
    load();
  }
  function escapeHtml(s){return String(s).replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]))}
  if(openBtn)openBtn.onclick=open;if(closeBtn)closeBtn.onclick=close;if(overlay)overlay.onclick=close;
  document.addEventListener('click',function(e){
    const btn=e.target.closest('[data-scroll]');if(btn){const el=document.querySelector(btn.dataset.scroll);if(el){e.preventDefault();el.scrollIntoView({behavior:'smooth'})}}
  });
  document.addEventListener('submit',async function(e){
    const form=e.target.closest('form[action*="/cart/add"]');if(!form)return;
    e.preventDefault();
    const fd=new FormData(form);
    const btn=form.querySelector('button[type="submit"]');
    let err=form.querySelector('.cart-error');
    if(!err){err=document.createElement('div');err.className='cart-error';err.setAttribute('role','alert');(btn&&btn.parentNode?btn.parentNode:form).appendChild(err)}
    err.textContent='';err.style.display='none';
    if(btn){btn.disabled=true;btn.dataset.old=btn.innerHTML;btn.innerHTML='Agregando…'}
    const restore=()=>{if(btn){btn.disabled=false;btn.innerHTML=btn.dataset.old||'Agregar al carrito'}};
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
      if(!r.ok){
        let msg='No se pudo agregar el producto al carrito.';
        try{const j=await r.json();msg=j.description||j.message||msg}catch(_){}
        err.textContent=msg;err.style.display='block';restore();return;
      }
      var wrap=form.closest('[data-after]'),after=wrap&&wrap.getAttribute('data-after');
      if(after==='cart'){window.location.href=wrap.getAttribute('data-cart-url')||'/cart';return}
      if(after==='checkout'){window.location.href='/checkout';return}
      restore();open();
    }catch(networkErr){restore();form.submit()}
  });
  load();
  function startCountdown(){
    const el=document.querySelector('[data-countdown]'); if(!el)return;
    const endHour=parseInt(el.dataset.endHour||'23',10);
    function tick(){
      const now=new Date(); const end=new Date(now); end.setHours(endHour,59,59,999);
      if(end<=now) end.setDate(end.getDate()+1);
      let ms=end-now; const h=Math.floor(ms/3600000); ms%=3600000; const m=Math.floor(ms/60000); const sec=Math.floor((ms%60000)/1000);
      const set=(sel,val)=>{const x=el.querySelector(sel); if(x)x.textContent=String(val).padStart(2,'0')};
      set('[data-hours]',h); set('[data-minutes]',m); set('[data-seconds]',sec);
    }
    tick(); setInterval(tick,1000);
  }
  startCountdown();
})();

(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-video-play]');if(!b)return;
    var wrap=b.closest('[data-video-cover]');var sec=b.closest('.lurex-video-section');
    var t=sec&&sec.querySelector('[data-video-template]');if(!wrap||!t)return;
    wrap.classList.remove('video-cover');wrap.removeAttribute('data-video-cover');wrap.innerHTML=t.innerHTML;
  });
})();


(function(){
  function init(root){
    if(root.__lurexInit)return; root.__lurexInit=true;
    var slides=[].slice.call(root.querySelectorAll('.banner-slide')),dots=[].slice.call(root.querySelectorAll('[data-go]')),i=0,t=null,x0=null;
    if(slides.length<2)return;
    function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)})}
    function stop(){if(t){clearInterval(t);t=null}}
    function start(){stop();if(root.getAttribute('data-autoplay')!=='true'||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;t=setInterval(function(){go(i+1)},(parseInt(root.getAttribute('data-interval'),10)||6)*1000)}
    root.addEventListener('click',function(e){var b=e.target.closest('[data-prev],[data-next],[data-go]');if(!b||!root.contains(b))return;if(b.hasAttribute('data-prev'))go(i-1);else if(b.hasAttribute('data-next'))go(i+1);else go(parseInt(b.getAttribute('data-go'),10));start()});
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;stop()},{passive:true});
    root.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;x0=null;if(Math.abs(dx)>50)go(dx<0?i+1:i-1);start()},{passive:true});
    root.addEventListener('shopify:block:select',function(e){var k=slides.indexOf(e.target);if(k>-1){go(k);stop()}});
    root.addEventListener('shopify:block:deselect',start);
    start();
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-carousel]'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

(function(){
  function mobileMenu(){
    var b=document.querySelector('[data-mobile-menu]'),n=document.querySelector('[data-mobile-nav]');
    if(!b||!n||b.__bound)return;b.__bound=true;
    b.addEventListener('click',function(){var open=n.classList.toggle('open');b.setAttribute('aria-expanded',open?'true':'false');});
    n.addEventListener('click',function(e){if(e.target.closest('a')){n.classList.remove('open');b.setAttribute('aria-expanded','false');}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mobileMenu);else mobileMenu();
  document.addEventListener('shopify:section:load',mobileMenu);
})();
(function(){
  document.addEventListener('click',function(e){
    var img=e.target.closest('[data-product-main-image]');if(!img)return;
    var wrap=img.closest('.product-main-media');if(wrap)wrap.classList.toggle('zoomed');
  });
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-product-thumb]');if(!t)return;
    var src=t.getAttribute('data-src'),alt=t.getAttribute('data-alt')||'';
    var main=document.querySelector('[data-product-main-image]');if(main&&src){main.src=src;main.alt=alt;document.querySelectorAll('[data-product-thumb]').forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active');}
  });
})();

(function(){function boot(){document.querySelectorAll('[data-product-carousel]').forEach(function(r){if(r.__pc)return;r.__pc=1;var t=[].slice.call(r.querySelectorAll('[data-product-thumb]')),i=0;if(t.length<2)return;function go(n){i=(n+t.length)%t.length;t[i].click();t[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}r.addEventListener('click',function(e){var b=e.target.closest('[data-product-prev],[data-product-next]');if(b)go(i+(b.hasAttribute('data-product-next')?1:-1))});var x=null;r.addEventListener('touchstart',function(e){x=e.touches[0].clientX},{passive:true});r.addEventListener('touchend',function(e){if(x===null)return;var d=e.changedTouches[0].clientX-x;x=null;if(Math.abs(d)>45)go(i+(d<0?1:-1))},{passive:true})});document.querySelectorAll('[data-reviews-carousel]').forEach(function(r){if(r.__rc)return;r.__rc=1;var t=r.querySelector('.reviews-track');if(!t)return;r.addEventListener('click',function(e){var b=e.target.closest('[data-review-prev],[data-review-next]');if(b)t.scrollBy({left:(b.hasAttribute('data-review-next')?1:-1)*Math.min(t.clientWidth*.88,900),behavior:'smooth'})})} )}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot)})();

(function(){
 function initProductSlider(){
  document.querySelectorAll('[data-product-carousel]').forEach(function(root){
   if(root.__sliderReady)return; root.__sliderReady=true;
   var thumbs=[].slice.call(root.querySelectorAll('[data-product-thumb]'));
   var main=root.querySelector('[data-product-main-image]'); if(!main||thumbs.length<2)return;
   var i=0,t;
   function go(n){i=(n+thumbs.length)%thumbs.length;var b=thumbs[i],src=b.getAttribute('data-src'),alt=b.getAttribute('data-alt')||'';main.src=src;main.alt=alt;thumbs.forEach(function(x,k){x.classList.toggle('is-active',k===i)});b.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
   root.addEventListener('click',function(e){var b=e.target.closest('[data-product-prev],[data-product-next]');if(b)go(i+(b.hasAttribute('data-product-next')?1:-1));});
   function start(){clearInterval(t);t=setInterval(function(){go(i+1)},4500)} function stop(){clearInterval(t)}
   root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
   var x=null;root.addEventListener('touchstart',function(e){x=e.touches[0].clientX;stop()},{passive:true});root.addEventListener('touchend',function(e){if(x===null)return;var d=e.changedTouches[0].clientX-x;x=null;if(Math.abs(d)>45)go(i+(d<0?1:-1));start()},{passive:true});start();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initProductSlider);else initProductSlider();
 document.addEventListener('shopify:section:load',initProductSlider);
})();
